import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import ManageSection from '@/views/parametres/configs/param-fiche-medical/manage-section'
import ManageFicheConsultation from '@/views/parametres/configs/param-fiche-medical/manage-fiche-consultation' 
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'liste-sections',
    components: {
        ManageSection, ManageFicheConsultation
    },
    props: {
        selected_consultation: Object,
        selected_fiche: Object,
        liste_autre_consultations: Array,
        info_user: Object,
        activeRole: Object
    },
    data() {
        return {
            vm_state: open_menu_state,

            fields: [
				'section', { key: 'etat', label: 'État' },  { key: 'actions', label: 'Action.s' }
			],
			filter_section: "",
			perPage: -1,
			currentPage: 1,

            section_loading: true,
            section_empty: false,
            liste_sections: [],
            modal_toggler: 0,
            section_to_edit: {},
            edit_modal_toggler: 0
        }
    },

    computed: {
        default_consultation_sections(){
            return this.$store.getters["default_consultation_sections"];
        },
    },

    mounted() {
        this.listeSectionFicheByTypeConsultation()

        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
    },

    methods: {
        listeDefaultConsultationSection() {
            this.section_loading = true
            let data = {
                is_default: 1,
                can_show: 0
            }
            this.$store.dispatch('getDefaultConsultationSections', data).then(() => {
                if (this.default_consultation_sections.length == 0) {
                    this.section_empty = true
                } else {
                    this.section_empty = false
                }

                this.section_loading = false
            })
        },

        listeSectionFicheByTypeConsultation() {
            this.section_loading = true
            let data = {
                type_consultation_id: this.selected_consultation.id,
                fiche_consultation_id: this.selected_fiche.id
            }
            store_fiche.getSectionByTypeConsultation(data).then((sections) => {
                this.liste_sections = sections
                if (sections.length == 0) {
                    this.section_empty = true
                } else {
                    this.section_empty = false
                }

                this.section_loading = false
            })
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        goToPage(goto_page) {
            this.$emit('emitGoToPage', goto_page)
        },

        editFiche() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0

            $('.add-fiche').modal('show')
        },

        viewFields(data) {
            this.goToPage('liste_champs')
            this.$emit('emitSetSection', data)
        },

        setSectionToEdit(data) {
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            this.section_to_edit = data
            $('.edit-section').modal('show')
        }, 

        orderSection() {
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            $('.order-evolution').modal('show')
        }
    }
}